<template lang="pug">
StandardChart(
  :input="chartData",
  maxWidth="100%",
  chartType="bar",
  :loading="loading",
  v-if="items"
)
  v-card-text
    DaysReport(:items="items")
</template>

<script>
import moment from "moment-timezone";
import DaysReport from "/libs/components/Order/Performance/DaysReport";

export default {
  components: { DaysReport },
  props: ["items", "loading"],
  computed: {
    chartData() {
      if (!this.items?.length) return;
      const month = moment(this.items[0].date).format("YYYY-MM");
      const title = `Sales in ${moment(this.items[0].date).format(
        "MMMM, YYYY"
      )}`;
      const monthToDates = this.$options.filters.monthToDates;
      const dates = monthToDates(month);
      const labels = dates.map((o) => moment(o).format("D"));
      const values = dates.map((o) => {
        const item = this.items.find((p) => p.date == o);
        return item?.sales?.total || 0;
      });
      values.forEach((o) => (o = Math.round(o * 100) / 100));
      return { title, labels, values, isCurrency: true };
    },
  },
};
</script>